<section id="service-schedule-container">
  <section id="schedule-rotation-list"
           *ngIf="!isEditMode">
    <section id='header'>
      <div class='title'>
        <div class='main'>{{ 'servicePersonnel.salesScheduleRotation' | translate }}</div>
      </div>

      <div class='actions'>
        <div (click)="onAddNewSchedule()" class='action'>{{'scheduleRotation.addANewSchedule' | translate }}<span class="plus">+</span></div>
      </div>
    </section>
    <!-- List -->
    <section id='schedule-list' *ngIf="!(scheduleRotationsLoading$ | async); else loader">
      <div class="empty-schedule-rotation"
           *ngIf="(scheduleRotations$ | async)?.length === 0">
        <mat-icon class="mat-icon">info_outline</mat-icon>
        <span
          class="label">{{ 'otherTexts.thereAreNoScheduleRotationsConfigured.PleaseAddOneByClickingAddNewSchedule' | translate }}</span>
      </div>
      <div *ngFor="let schedule of (scheduleRotations$ | async)">
        <app-schedule-list [scheduleData]='schedule'></app-schedule-list>
      </div>
    </section>
  </section>
  <!-- Edit mode -->
  <section id="schedule-rotation-edit"
           *ngIf="isEditMode">
    <app-schedule-rotation-edit *ngIf="!(scheduleRotationsLoading$ | async); else loader"
                                [department]="department" [scheduleId]="scheduleId"
                                (formsEdited)="valuesChanged($event)"
                                [saveClicked]="saveClicked"></app-schedule-rotation-edit>
  </section>
</section>
<ng-template #loader>
  <div id="schedule-rotation-loader">
    <app-loading loadingSymbol="dots" text="{{'scheduleRotation.loading' | translate }}" color="var(--primary-sec-color)"></app-loading>
  </div>
</ng-template>
